<template>
  <View direction="column" gap="xs" class="section-header">
    <Text variant="h3">{{ title }}</Text>
    <Text v-if="description" variant="body-medium" color="secondary" class="description">{{ description }}</Text>
  </View>
</template>

<script setup lang="ts">
import { Text, View } from '@tallo/design-system';

/** Names a group of detail cards and says how they behave, above its grid */
defineProps<{ title: string; description?: string }>();
</script>

<style scoped lang="scss">
.section-header {
  padding-top: var(--t-spacing-sm);
}

// A line of explanation reads as one; the grid below is wider than that
.description {
  max-width: 40rem;
}
</style>
